import axios from 'common/bsac-api.js';
import constants from 'common/constants';
import prototype from 'prototype/product';

const state = {
  /**
   * インポートした商品リスト
   */
  importedProducts: [],
  /**
   * 商品リスト
   */
  products: [],
};

const getters = {
  /**
   * インポートした商品リストを取得する
   * @param {*} state
   * @returns 商品リスト
   */
  importedProducts: (state) => state.importedProducts,
  /**
   * 商品リストを取得する
   * @param {*} state
   * @returns 商品リスト
   */
  products: (state) => state.products,
  /**
   * CSV用商品リストを取得する
   * @param {*} state
   * @returns 商品リストCSV（ヘッダー付き）
   */
  productsForCsv: (state) => new prototype.Product().getCsv(state.products, true),
};

const mutations = {
  /**
   * データをクリアする
   * @param {*} state
   */
  clearData(state) {
    state.importedProducts = [];
    state.products = [];
  },
  /**
   * インポートした商品リストをクリアする
   * @param {*} state
   */
  clearImportedProducts(state) {
    state.importedProducts = [];
  },
  /**
   * 商品リストをセットする
   * @param {*} state
   * @param {*} products
   */
  setProducts(state, products) {
    state.products = [];
    products.forEach(function (product) {
      let newProduct = new prototype.Product();
      newProduct.setApiData(product);
      state.products.push(newProduct);
    });
  },
  /**
   * CSVから商品リストをセットする
   * @param {*} state
   * @param {*} payload
   */
  setProductsFromCsv(state, payload) {
    // console.debug(`payload: ${JSON.stringify(payload)}`);
    let lineNo = payload.withHeader ? 2 : 1;
    state.importedProducts = [];
    payload.products.forEach(function (product) {
      let newProduct = new prototype.Product();
      newProduct.setCsvData(product, lineNo);
      if (Object.keys(product).length === 19) state.importedProducts.push(newProduct);
      lineNo++;
    });
  },
};

const actions = {
  /**
   * インポートを実行する
   * @param {*} param0
   */
  async doImport({ getters, dispatch }) {
    const inportedProducts = getters['importedProducts'];
    let success = true;
    for (let i = 0; i < inportedProducts.length; i++) {
      let product = inportedProducts[i];
      if (product.id === constants.SELECTBOX_NOT_SELECTED.value) {
        product.result = await dispatch('register', product);
        // console.debug(`新規 id: ${product.id} result: ${JSON.stringify(product.result)}`);
      } else {
        product.result = await dispatch('update', product);
        // console.debug(`更新 id: ${product.id} result: ${JSON.stringify(product.result)}`);
      }
      success = success && product.result.success;
    }
    // 結果のチェック;
    let result = success
      ? { success: true, status: null, message: '処理が完了しました' }
      : { success: false, status: null, message: 'エラーが発生しました' };
    // console.debug(`全体の結果 result: ${JSON.stringify(result)}`);
    return result;
  },
  /**
   * APIを呼び出し商品情報を取得する
   * @param {*} param0
   * @param {*} productId 商品ID
   * @returns
   */
  getProduct({ getters, rootGetters }, productId) {
    let product = new prototype.Product();
    if (productId === constants.SELECTBOX_NOT_SELECTED.value) return product;
    const headers = rootGetters['admin/authHeaders'];
    // console.log(`header: ${JSON.stringify(headers)}`);
    return axios
      .get(`${constants.ADMIN_API_URL}/products/${productId}`, headers)
      .then((response) => {
        // console.debug('response:' + JSON.stringify(response));
        product.setApiData(response.data.data);
        return product;
      })
      .catch((error) => {
        // console.error(error.response);
        return product;
      });
  },
  /**
   * APIを呼び出し商品リストを取得する
   * @param {*} param0
   * @param {*} state
   * @returns
   */
  getProducts({ commit, rootGetters }, searchCondition) {
    const headers = rootGetters['admin/authHeaders'];
    // console.log(`header: ${JSON.stringify(headers)}`);
    const query = searchCondition ? `?${new URLSearchParams(searchCondition).toString()}` : '';
    // console.log(`query: ${query}`);
    return axios
      .get(`${constants.ADMIN_API_URL}/products${query}`, headers)
      .then((response) => {
        // console.debug('response:' + JSON.stringify(response));
        commit('setProducts', response.data.data);
        return {
          success: true,
          status: null,
          message: null,
        };
      })
      .catch((error) => {
        console.error(error.response);
        return {
          success: false,
          status: null,
          message: null,
        };
      });
  },
  /**
   * APIを呼び出し商品情報を登録する
   * @param {*} param0
   * @param {*} product 商品情報
   * @returns
   */
  register({ getters, rootGetters }, product) {
    if (!product || product.id !== constants.SELECTBOX_NOT_SELECTED.value) {
      return {
        success: false,
        status: null,
        message: '引数が不正です',
      };
    }
    const headers = rootGetters['admin/authHeaders'];
    const requestBody = product.getRequestBody();
    return axios
      .post(`${constants.ADMIN_API_URL}/products`, requestBody, headers)
      .then((response) => {
        // console.debug('response:' + JSON.stringify(response));
        return {
          success: true,
          status: response.status,
          message: '商品を登録しました',
        };
      })
      .catch((error) => {
        // console.error('error:' + JSON.stringify(error));
        return {
          success: false,
          status: error.status,
          message: error.message,
        };
      });
  },
  /**
   * APIを呼び出し商品を更新する
   * @param {*} param0
   * @param {*} product 商品情報
   * @returns
   */
  update({ getters, rootGetters }, product) {
    if (!product || product.id === constants.SELECTBOX_NOT_SELECTED.value) {
      return {
        success: false,
        status: null,
        message: '引数が不正です',
      };
    }
    const headers = rootGetters['admin/authHeaders'];
    const requestBody = product.getRequestBody();
    return axios
      .patch(`${constants.ADMIN_API_URL}/products/${product.id}`, requestBody, headers)
      .then((response) => {
        // console.debug('response:' + JSON.stringify(response));
        return {
          success: true,
          status: response.status,
          message: '商品を更新しました',
        };
      })
      .catch((error) => {
        // console.error('error:' + JSON.stringify(error));
        return {
          success: false,
          status: error.status,
          message: error.message,
        };
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
